import { render, staticRenderFns } from "./TrademarkDetailForm.vue?vue&type=template&id=307c087e&"
import script from "./TrademarkDetailForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkDetailForm.vue?vue&type=style&index=0&id=307c087e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports